// extracted by mini-css-extract-plugin
export default {"box":"file-uploader_box__zKP4x","progress":"file-uploader_progress__+XDhT","progressValue":"file-uploader_progressValue__SsdsY"};